import React from "react";
import { Link } from "react-router-dom";
import mobileSolutionsPhoto from "../Assets/mobile solution.jpg";
import Heading from "../reusable-components/fonts/Heading";
const services = [
  "Websites / Web Apps / Portals",
  "In-Premise Applications",
  "Mobile Solutions",
  "e-Governance Solutions",
  "e-Commerce Solutions",
  "Software Consultancy",
  "SEO Consultancy",
  "Chatbots",
  "Soft Skills Training",
];
<div className="min-h-screen w-full relative">
  {/* Radial Gradient Background from Bottom */}
  <div
    className="absolute inset-0 z-0"
    style={{
      background: "radial-gradient(125% 125% at 50% 90%, #fff 40%, #6366f1 100%)",
    }}
  />
     {/* Your Content/Components */}
</div>
const OurServicesHomeDark = () => {
  return (
    <div className="min-h-screen w-full relative">
       <div
        className="absolute inset-0 z-0  hidden lg:block"
        style={{
          background: "radial-gradient(190% 125% at 50% 90%, #ffffff 28%, #c3c3e5 35%, #5a5a9a 48%, #090921 68%)",
        }}
      />
      <div
        className="absolute inset-0 z-0 lg:hidden"
        style={{
          background: "linear-gradient(to top, #ffffff 20%, #e0e0f0 40%, #a0a0d0 60%, #5a5a9a 75%, #090921 100%)",
        }}
      />
    <section className="relative w-full py-6 px-6 md:px-10 font-poppins">
      
      {/* Heading */}
      <Heading className="text-3xl pb-0 flex flex-row justify-center font-semibold my-5 lg:my-8 lg:pb-0 mb-6 tracking-tight">
        <div className="text-white ">Our Services</div>
      </Heading>

      {/* Image */}
      <div className="flex justify-center mt-10 mb-5">
        <img
          src={mobileSolutionsPhoto}
          alt="Our services"
          className="rounded-3xl shadow-xl w-full max-w-md object-cover"
        />
      </div>

      {/* Subheading */}
      <div className="text-center mb-4">
        <h3 className="text-3xl font-semibold text-secondary">Services provided by us:</h3>
      </div>

      {/* Intro Text */}
      <div className="max-w-3xl mx-auto text-center text-secondarytext-lg md:text-lg mb-10 leading-relaxed">
        Our company provides a wide range of services to help businesses build and maintain an effective online presence. Here are some of the key services we offer:
      </div>

      {/* Mobile Layout (<lg) */}
      <div className="block lg:hidden max-w-5xl mx-auto space-y-4">
      {/* First Button - full width and centered */}
      <div className="flex justify-center ">
        <Link
          to="/our-services#service1"
          className="w-64 group block bg-white border-2 border-secondary rounded-xl p-4 text-center hover:border-[#E75124] hover:shadow-md transition-all duration-300"
        >
          <div className="text-base font-semibold text-gray-800 group-hover:text-[#E75124] transition truncate">
            {services[0]}
          </div>
        </Link>
      </div>


        {/* Remaining Buttons in 2-column grid */}
        <div className="grid grid-cols-2 gap-4">
          {services.slice(1).map((service, index) => (
            <Link
              to={`/our-services#service${index + 2}`}
              key={index}
              className="group block bg-white border-2 border-secondary rounded-xl p-4 text-center hover:border-[#E75124] hover:shadow-md transition-all duration-300"
            >
              <div className="text-sm font-semibold text-gray-800 group-hover:text-[#E75124] transition truncate">
                {service}
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Desktop Layout (lg and up) */}
      <div className="hidden lg:grid max-w-5xl mx-auto grid-cols-3 gap-4">
        {services.map((service, index) => (
          <Link
            to={`/our-services#service${index + 1}`}
            key={index}
            className="group block bg-white border-2 border-secondary rounded-xl p-4 text-center hover:border-[#E75124] hover:shadow-md transition-all duration-300"
          >
            <div className="text-base font-semibold text-gray-800 group-hover:text-[#E75124] transition truncate">
              {service}
            </div>
          </Link>
        ))}
      </div>


    </section>
    </div>
  );
};

export default OurServicesHomeDark;
